/** 서버가 `REVIEW_NOT_FOUND` 로 거절했는지 — 없는 후기·삭제된 후기·남의 후기가 모두 여기에 든다. */
export const isReviewNotFound = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return false;
  const data = (error as { data: unknown }).data;
  return (
    typeof data === 'object' &&
    data !== null &&
    'reviewErrorCode' in data &&
    (data as { reviewErrorCode: unknown }).reviewErrorCode === 'REVIEW_NOT_FOUND'
  );
};
